<span
  class="ingrid-toggle"
  (click)="toggle()"
  [ngClass]="{ 'ingrid-toggle_active': isActive }"
>
  <span class="ingrid-toggle__button"></span>
</span>
